import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { DateFilter } from "~/components/Filters/DateFilter/DateFilter";
export const ModifiedDateFilter = /*#__PURE__*/ memo((param)=>{
    let { startDate, endDate, dateType, onStartDateChange, onEndDateChange, onTypeChange } = param;
    return /*#__PURE__*/ _jsx(DateFilter, {
        startDate: startDate,
        endDate: endDate,
        selectedType: dateType,
        onStartDateChange: onStartDateChange,
        onEndDateChange: onEndDateChange,
        onTypeChange: onTypeChange
    });
});
ModifiedDateFilter.displayName = "ModifiedDateFilter";
